// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__31Zou","empty":"ModalGraph_empty__3u71p"};